import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaClock,
  FaStar,
  FaUtensils,
  FaPhoneAlt,
} from "react-icons/fa";
import { useDispatch } from "react-redux";
import { gettravelHotel } from "../../store/slices/travelhotel";
import Carousel from "react-bootstrap/Carousel";

export default function HotelDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [hotel, setHotel] = useState(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchHotel();
  }, [id]);

  const fetchHotel = async () => {
    setLoading(true);
    try {
      const res = await dispatch(gettravelHotel({ id })).unwrap();
      setHotel(res?.hotel);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // if (!hotel) return <div className="text-center py-5">Loading...</div>;

  const images = hotel?.image
    ? Array.isArray(hotel?.image)
      ? hotel?.image
      : [hotel?.image]
    : [];

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <Link to="/admin/hotels" className="breadcrumb-link active">
            Hotels
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive">Hotel Details</span>
        </div>
      </div>

        {loading ? (

          <Container className="my-3">

            
            <div className="mb-4">
              <div className="skeleton skeleton-img w-100" style={{ height: "400px" }}></div>
            </div>
          
            <div className="rounded-4 mb-4 p-4">
              <div className="skeleton skeleton-text mb-2" style={{ width: "40%" }}></div>
              <div className="skeleton skeleton-text mb-2" style={{ width: "60%" }}></div>
              <div className="skeleton skeleton-badge" style={{ width: "100px" }}></div>
            </div>

            <Row>

              <Col md={6}>
                <Card className="mb-4 rounded-4">
                  <Card.Body>
                    <div className="skeleton skeleton-text mb-3" style={{ width: "50%" }}></div>
                    <div className="skeleton skeleton-text mb-2"></div>
                    <div className="skeleton skeleton-text"></div>
                  </Card.Body>
                </Card>
              </Col>

            
              <Col md={6}>
                <Card className="mb-4 rounded-4">
                  <Card.Body>
                    <div className="skeleton skeleton-text mb-3" style={{ width: "50%" }}></div>
                    <div className="skeleton skeleton-text mb-2"></div>
                    <div className="skeleton skeleton-text"></div>
                  </Card.Body>
                </Card>
              </Col>

              
              <Col lg={12}>
                <Card className="mb-4 rounded-4">
                  <Card.Body>
                    <div className="skeleton skeleton-text mb-3" style={{ width: "30%" }}></div>

                    {[...Array(3)].map((_, i) => (
                      <div
                        key={i}
                        className="d-flex justify-content-between p-3 mb-2 rounded-3"
                      >
                        <div className="skeleton skeleton-text w-50"></div>
                        <div className="skeleton skeleton-text" style={{ width: "80px" }}></div>
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              </Col>

            </Row>

          </Container>

      ) : (

        <Container className="my-3">
          {/* Image Carousel */}
          
          {images.length > 0 && (
            <div className="mb-4">
              <Carousel fade>
                {images.map((img, index) => (
                  <Carousel.Item key={index}>
                    <div
                      style={{
                        position: "relative",
                        borderRadius: "20px",
                        overflow: "hidden",
                        backgroundColor: "none",
                      }}
                    >
                      <img
                        src={img}
                        alt="hotel"
                        className="w-100"
                        style={{
                          height: "500px",
                          objectFit: "cover",
                          padding: "10px",
                          filter:
                            "contrast(150%) brightness(105%) saturate(120%)",
                          imageRendering: "auto",
                          borderRadius: "20px",
                        }}
                      />

                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          background:
                            "linear-gradient(to bottom, rgba(86, 45, 200, 0.2), rgba(0, 0, 0, 0.3))",
                        }}
                      />
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          )}

          <div
            style={{
              background: "#3c1361",
              color: "#fff",
              boxShadow:
                " rgba(112, 21, 209, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset",
            }}
            className="rounded-4 mb-4 p-4"
          >
            <Row className="align-items-center">
              <Col md={8}>
                <h2 className="fw-bold">{hotel?.name}</h2>
                <p>
                  <FaMapMarkerAlt className="me-2 text-warning" />
                  {hotel?.address}, {hotel?.city}
                </p>

                <div>
                  <Badge
                    style={{
                      background: "#F4C430",
                      color: "#000",
                      marginLeft: "10px",
                    }}
                  >
                    {hotel?.category}
                  </Badge>
                </div>
              </Col>
            </Row>
          </div>

          {/* Details Section */}
          <Row>
            <Col md={6}>
              {/* Contact Card */}
              <Card
                className=" border-0 mb-4 rounded-4 hoteldetailshover-card "
                style={{
                  boxShadow:
                    " rgba(112, 21, 209, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset",
                }}
              >
                <Card.Body>
                  <h5 style={{ color: "#1E0959" }}>Contact Information</h5>
                  <p>
                    <FaPhoneAlt className="me-2 text-warning" />
                    {hotel?.contactNumber}
                  </p>
                  <p>
                    <FaEnvelope className="me-2 text-warning" />
                    {hotel?.email}
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              {/* Check In -  Out */}
              <Card
                className="border-0 mb-4 rounded-4 hoteldetailshover-card "
                style={{
                  boxShadow:
                    " rgba(112, 21, 209, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(237, 233, 10, 0.08) 0px 1px 0px inset",
                }}
              >
                <Card.Body>
                  <h5 style={{ color: "#1E0959" }}>Check-In / Check-Out</h5>
                  <p>
                    <FaClock className="me-2 text-warning" />
                    Check-In: {hotel?.checkInTime}
                  </p>
                  <p>
                    <FaClock className="me-2 text-warning" />
                    Check-Out: {hotel?.checkOutTime}
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={12}>
              {/* Addons */}
              {hotel?.addons?.length > 0 && (
                <Card
                  className="border-0 mb-4 rounded-4   "
                  style={{
                    boxShadow:
                      " rgba(112, 21, 209, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(237, 233, 10, 0.08) 0px 1px 0px inset",
                  }}
                >
                  <Card.Body>
                    <h5 style={{ color: "#1E0959" }}>Addons</h5>
                    {hotel?.addons?.map((addon, index) => (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center p-3 mb-2 rounded-3 hoteldetailshover-card"
                        style={{ background: "#F8F6FF" }}
                      >
                        <div>
                          <FaUtensils className="me-2 text-warning" />
                          {addon?.name || "-"} ({addon?.type})
                        </div>
                        <strong style={{ color: "#1E0959" }}>
                          ₹ {addon?.price}  
                        </strong>
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>

          {/* Star Animation */}
          <style>
            {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
          }
        `}
          </style>
        </Container>

      )}

    </>
  );
}
